import React from "react";
import styled from "styled-components";
import { LabelValue } from "../platform/types/LabelValue";
import { Colors } from "./Colors";

const Select = styled.select`
    padding: .125rem;
    width: 100%;
    border: solid 1px ${Colors.border};
    border-radius: .25rem;
    background: white;
`;

export const NativeSelect = React.memo<{ options: LabelValue[], value: string, onSelect: (newValue: string) => void }>(({ options, value, onSelect }) =>
    <Select value={value} onChange={e => onSelect(e.target.value as any)}>
        {options.map(x =>
            <option key={x.value} value={x.value}>
                {x.label}
            </option>
        )}
    </Select>
);